export const getSanitizedMentionBody = (inputString: string): string => {
    const regex = /@<[^>]+>([^*]+)/g
    return inputString.replace(regex, '@$1').replace(/\*/g, '')
}
